import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TopbarComponent } from './topbar.component';


@NgModule({
    imports: [CommonModule],
    declarations: [TopbarComponent],
    exports: [TopbarComponent],
    providers: []
})
export class TopbarModule { }


// WEBPACK FOOTER //
// ./src/app/core/masterComponent/topbar.module.ts